// Component
const ModalMultiplePrice = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-multiple-price"*/ "@/app/views/main-view/_shared/_components/modals/modal-multiple-price/modal-multiple-price.vue"
	)

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { productMixins } from "@/app/mixins/modules/product-mixins.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"

// Services
import productService from "@/app/services/main/product/product-service.js"

// Constants
import { STATUS_CODES, SUBSCRIPTION_PERIOD } from "@/app/constants/constants"

export default {
	name: "ProductsContainer",
	components: {
		ModalMultiplePrice,
	},
	mixins: [tableMixins, productMixins, toastMessageMixins],
	data() {
		return {
			subPeriod: SUBSCRIPTION_PERIOD,
			isAPILoading: true,
			modalContent: {},
			// table
			theads: [
				{ name: "SKU", searchLabel: "f_sku", sortLabel: "sku", isDesc: false, hasSearch: true },
				{ name: "Image", searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false },
				{ name: "Name", searchLabel: "f_name", sortLabel: "name", isDesc: false, hasSearch: true },
				{
					name: "Type",
					searchLabel: "f_productTypeName",
					sortLabel: "productTypeId",
					isDesc: false,
					hasProductTypeSearch: true,
				},
				{
					name: "Brand",
					searchLabel: "f_brandName",
					sortLabel: "brandId",
					isDesc: false,
					hasBrandSearch: true,
				},
				{ name: "Price", searchLabel: "f_price", sortLabel: "price", isDesc: false, hasSearch: true },
				{ name: "Size", searchLabel: "f_size", sortLabel: "size", isDesc: false, hasSizeSearch: true },
				{ name: "Age", searchLabel: "f_age", sortLabel: "age", isDesc: false, hasAgeSearch: true },
				{ name: "Available Qty", searchLabel: "f_quantity", sortLabel: null, isDesc: false },
				{ name: "Status", searchLabel: "f_status", sortLabel: "status", isDesc: false, hasStatusSearch: true },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
			],
			// sorting
			desc: true,
			lowOnStockToggleCheckbox: false,
			onSaleToggleCheckBox: false,
			subscriptionToggleCheckbox: false,
			outOfStockToggleCheckbox: false,
		}
	},
	props: {
		isDashboard: {
			type: Boolean,
			default: false,
		},
	},
	created() {
		this.getProductTypeList()
		this.getSubscriptionPeriodList()
		this.getTableContent()
	},
	activated() {
        // this lifecycle method will only be called for components under keep-alive
        this.getTableContent();
	},
	methods: {
		rowStyle(product) {
			const quantity = product.quantity ? product.quantity : 0
			const minStock = product.minStock ? product.minStock : 0
			const lowStock = quantity <= minStock

			return quantity === 0 ? "color: red;" : lowStock ? "color: orange;" : ""
		},
		getProductList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_sku) {
					queryParams["f_sku"] = this.columnsFilter.f_sku
				}
				if (this.columnsFilter.f_name) {
					queryParams["f_name"] = this.columnsFilter.f_name
				}
				if (this.columnsFilter.f_productTypeName) {
					queryParams["f_productTypeName"] = this.columnsFilter.f_productTypeName
				}
				if (this.columnsFilter.f_brandName) {
					queryParams["f_brandName"] = this.columnsFilter.f_brandName
				}
				if (this.columnsFilter.f_price) {
					queryParams["f_price"] = this.columnsFilter.f_price
				}
				if (this.columnsFilter.f_size) {
					queryParams["f_size"] = this.columnsFilter.f_size
				}
				if (this.columnsFilter.f_age) {
					queryParams["f_age"] = this.columnsFilter.f_age
				}
				if (this.subscriptionToggleCheckbox) {
					queryParams["f_subscriptionBundle"] = this.subscriptionToggleCheckbox
				}
				if (this.columnsFilter.f_status) {
					queryParams["f_status"] = this.columnsFilter.f_status
				}
				if (this.columnsFilter.f_description) {
					queryParams["f_description"] = this.columnsFilter.f_description
				}
				if (this.onSaleToggleCheckBox) {
					queryParams["f_onSale"] = this.onSaleToggleCheckBox
				}
				if (this.columnsFilter.f_lowStock) {
					queryParams["f_lowStock"] = this.lowOnStockToggleCheckbox
				}
				if (this.outOfStockToggleCheckbox) {
					queryParams["f_oufOfStock"] = this.outOfStockToggleCheckbox
				}
			}

			this.isAPILoading = true

			productService.getProducts(queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.tableContent = {
						tableData: res.data.data,
						paginationData: res.data.pagination,
					}
					this.isAPILoading = false
				} else {
					this.showAPIErrorToast("Unable to fetch product list.", res)
					this.isAPILoading = false
				}
			})
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page
			this.getProductList({ page, limit, sortBy, desc })
		},
		deleteProduct(event, product) {
			// show modal confirmation
			if (!event.target.checked) {
				this.$swal({
					title: "Deactivate Product",
					text: `Are you sure you want to deactivate ${product.name}?`,
					confirmButtonText: "Confirm",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
					showCloseButton: true
				}).then((result) => {
					if (result.value) {
						// API call for delete
						productService.deleteProduct(product.id).then((res) => {
							const { SUCCESS_DEACTIVATE_TITLE, SUCCESS_DEACTIVATE_TEXT, ERROR_DEACTIVATE_PRODUCT_TEXT } =
								this.toastMessages.product(product.name)

							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast(SUCCESS_DEACTIVATE_TITLE, SUCCESS_DEACTIVATE_TEXT)
								this.isAPILoading = false
								// refresh table with filter
								this.getTableContent()
							} else {
								this.showAPIErrorToast(ERROR_DEACTIVATE_PRODUCT_TEXT, res)
								event.target.checked = true
								this.isAPILoading = false
							}
						})
					} else {
						event.target.checked = true
					}
				})
			}
		},
		reactivateProduct(event, product) {
			// show modal for checked
			if (event.target.checked) {
				this.$swal({
					title: "Reactivate Product",
					text: `Are you sure you want to reactivate ${product.name}?`,
					confirmButtonText: "Confirm",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
					showCloseButton: true
				}).then((result) => {
					if (result.value) {
						// API call for reactivate
						productService.reactivateProduct(product.id).then((res) => {
							const { SUCCESS_ACTIVATE_TITLE, SUCCESS_ACTIVATE_TEXT, ERROR_ACTIVATE_PRODUCT } =
								this.toastMessages.product(product.name)

							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast(SUCCESS_ACTIVATE_TITLE, SUCCESS_ACTIVATE_TEXT)

								this.isAPILoading = false
								// refresh table with filter
								this.getTableContent()
							} else {
								this.showAPIErrorToast(ERROR_ACTIVATE_PRODUCT, res)
								event.target.checked = false
								this.isAPILoading = false
							}
						})
					} else {
						event.target.checked = false
					}
				})
			}
		},
		hasProductImage(productImage) {
			let image = require("@/assets/images/temporary/product-image.png")

			if (productImage) {
				image = productImage
			}

			return image
		},
		showMultiplePriceModal(product) {
			if (product.subscriptionBundle) {
				const { price: monthlyPrice, quarterlyPrice, yearlyPrice, name: productName } = product
				this.modalContent = {
					name: productName,
					monthlyPrice,
					quarterlyPrice,
					yearlyPrice,
				}

				setTimeout(() => {
					this.$refs.modalMultiplePrice.show()
				}, 100)
			}
		},
		productDelete(product) {
			this.$swal({
				title: "Delete Product",
				text: `Are you sure you want to delete ${product.name}?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					// API call for delete
					productService.productDelete(product.id).then((res) => {
						const { SUCCESS_DELETE_PRODUCT_TITLE, SUCCESS_DELETE_TEXT, ERROR_DEACTIVATE_PRODUCT_TEXT } =
							this.toastMessages.product(product.name)

						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(SUCCESS_DELETE_PRODUCT_TITLE, SUCCESS_DELETE_TEXT)
							this.isAPILoading = false
							// refresh table with filter
							this.getTableContent()
						} else {
							this.showAPIErrorToast(ERROR_DEACTIVATE_PRODUCT_TEXT, res)
							this.isAPILoading = false
						}
					})
				}
			})
		},
		showDescriptionModal(description) {
			if (description) {
				this.$swal({
					title: "Product Description",
					text: description,
					showCancelButton: false,
					cancelButtonText: "Cancel",
					reverseButtons: true,
					showCloseButton: true
				})
			}
		},
		handleToggleCheckbox(fieldname, event) {
			switch (fieldname) {
				case "f_lowStock":
					this.lowOnStockToggleCheckbox = !this.lowOnStockToggleCheckbox
					break
				case "f_onSale":
					this.onSaleToggleCheckBox = !this.onSaleToggleCheckBox
					break
				case "f_oufOfStock":
					this.outOfStockToggleCheckbox = !this.outOfStockToggleCheckbox
					break
				default:
					this.subscriptionToggleCheckbox = !this.subscriptionToggleCheckbox
					break
			}
			this.onFilter(fieldname, event)
		},
	},
}
